<!-- <div class="row back-drop">
    <div class="col-md-4 col-lg-4 msg_display">
     
      <div class="error_text">{{error}}</div>
       <div class="text-right btn-action">
        <button type="button" class="btn btn-primary btn-bg" (click) = "onCloseClick()">Close</button>
    </div>
</div>
</div> -->
<div class="row">
    <div class="col-md-12 col-lg-12 pmsg-error">
        <p-messages [(value)]="errormsg"></p-messages>       
</div>
</div>